<template>
  <div class="chart-content">
    <div class="chart" ref="myChart">
    </div>
  </div>
</template>

<script>
import elementResizeDetectorMaker from "element-resize-detector";
// import {
//   GetPurchaseComposes
// } from '@/api'
import BaseReportMixin from '@/mixin/baseReport-mixin.js'

export default ({
  mixins: [BaseReportMixin],
  data () {
    return {
      myChart: null,
      option: {},
      data: [],
      setInterval: null
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    getDataAction: {
      type: Function,
      default () {
        return null
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
    data: {
      handler (newVal, oldVal) {
        // console.log(this.isShowCloseBtn, 'isShowCloseBtn,pie')
        this.initOption()
        this.option.series[0].data = newVal
        if (!this.myChart) {
          this.myChart = this.$echarts.init(this.$refs['myChart'])
        }
        this.myChart.setOption(this.option);
      },
      deep: true
    }
  },
  methods: {
    // 获取列表
    getData () {
      this.getDataAction({})
        .then(res => {
          this.data = res.returnData
          // console.log(this.data)
          // this.myChart.setOption(this.option);
          // this.init(res.returnData)
        })
    },

    initOption () {
      let that = this;
      var data = this.data
      this.option = {
        title: {
          text: this.name,
          textStyle: {
            color: "#FFF" // 标题颜色
          },
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'right',
          top: 'center',
          align: 'left',
          textStyle: {
            fontSize: 12,//字体大小
            color: '#fff',//修改标签字体颜色
          },
          formatter: function (name) {
            var d = data.find(e => e.name == name)
            return name + " " + (d.ratio * 100).toFixed(2) + '%'
          }
        },
        series: [
          {
            // name: '备货构成',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            // itemStyle: {
            //   borderRadius: 10,
            //   borderColor: '#fff',
            //   borderWidth: 2, 
            // },
            label: {
              show: false,
              // position: 'center'
            },
            labelLine: {
              show: false
            },
            data: [],
            center: ["30%", "55%"],
          }
        ],
        toolbox: this.getToolBox(this),
      }
    },


    init () {
      // this.initOption()
      this.myChart = this.$echarts.init(this.$refs['myChart'])
      // this.myChart.setOption(this.option);

      // // 随窗口的大小变化自适应
      // window.addEventListener("resize", function () {
      //   myChart.resize();
      // });
      //  随外层div的大小变化自适应
      const _this = this
      let erd = elementResizeDetectorMaker();
      let myChart = this.$refs.myChart
      erd.listenTo(myChart, (e) => {
        _this.$nextTick(() => {
          _this.myChart.resize();
          let parentNode = myChart.parentNode
          // console.log(parentNode, 'parentNode')
          _this.$emit('SizeChange', myChart.clientWidth, myChart.clientHeight, parentNode.parentElement.id)
        })
      })
    }


  },//自定义指令


  mounted () {
    this.getData();
    this.init()
    let that = this

    this.setInterval = setInterval(function () {
      that.getData();
    }, 5 * 60 * 1000);//每隔1秒执行每次刷新数据的函数
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
  },
  beforeDestroy () {
    clearInterval(this.setInterval)
  },
})
</script>
<style scoped lang="scss">
.chart-content {
  width: 400px;
  height: 200px;
  display: flex;

  .chart {
    width: 100%;
    height: 100%;
    position: absolute;
  }
}
</style>
